import React from 'react';

export type ConversionType = 'INR' | 'Lakhs' | 'Crores';

interface Props {
    value: ConversionType;
    onChange: (type: ConversionType) => void;
}

const UnitToggle: React.FC<Props> = ({ value, onChange }) => (
    <div className="flex gap-2">
        {(['INR', 'Lakhs', 'Crores'] as const).map((type) => (
            <button
                key={type}
                className={`px-3 py-1 text-sm rounded-md transition-colors ${value === type
                    ? 'bg-black text-white'
                    : 'bg-white border border-black hover:bg-gray-200'
                    }`}
                onClick={() => onChange(type)}
            >
                {type}
            </button>
        ))}
    </div>
);

export default UnitToggle;
